import AbstractProvidedClass from "../shared/AbstractProvidedClass";

export default class Menu extends AbstractProvidedClass {
    config = {
        'select': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#cursor-fill"></use></svg>',
            'tooltip': 'Select (C)',
            'callback': () => this.tools.setTool('select'),
        },
        'shapes': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#shape-line"></use></svg>',
            'tooltip': 'Shapes (A)',
            'callback': () => this.tools.setTool('shapes'),
        },
        'navigation': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#drag-move-2-fill"></use></svg>',
            'tooltip': 'Navigate (N)',
            'callback': () => this.tools.setTool('navigate'),
        },
        'erase': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#eraser-line"></use></svg>',
            'tooltip': 'Eraser (E)',
            'callback': () => this.tools.setTool('erase'),
        },
        'image': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#image-2-line"></use></svg>',
            'tooltip': 'Image (SHIFT + I)',
            'callback': () => this.tools.setTool('image'),
        },
        'settings': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#list-settings-fill"></use></svg>',
            'tooltip': 'Settings (,)',
            'callback': () => this.tools.setTool('settings'),
        },
        'help': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#question-line"></use></svg>',
            'tooltip': 'Help (H)',
            'callback': () => this.tools.setTool('help'),
        },
        'reset': {
            'icon': '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#refresh-line"></use></svg>',
            'tooltip': 'Reset view (SHIFT + R)',
            'callback': () => this.view.reset(),
        },
        'save': {
            'icon': 'Save',
            'tooltip': 'Save (CTRL+S)',
            'callback': () => this.dataHandler.savePlan(),
        },
    };

    init(leftButtons, rightButtons) {
        this.container = this.p.createDiv()
            .parent('#p5canvas')
            .class("planner-toolbar")
            .style('z-index', 1000);

        this.leftButtons = leftButtons.map((button) => this.createMenuButton(button));
        this.rightButtons = rightButtons.map((button) => this.createMenuButton(button));
    }

    createMenuButton(name) {
        let config = this.config[name];
        let buttonName = `${name}Button`;
        window[buttonName] = this.p.createButton(config['icon'])
            .parent(this.container)
            .class('btn-icon-clear -u-tt-bottom')
            .attribute('data-tooltip', config['tooltip'])
            .mousePressed(config['callback']);
        return window[buttonName];
    }
}
